var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pqaaso97ia",
    width: "155.6%",
    height: "155.6%",
    x: "-27.8%",
    y: "-18.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200147509 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "jk1agwbtub",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1317 -202) translate(1324 205)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#pqaaso97ia)",
    xlinkHref: "#jk1agwbtub"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#jk1agwbtub"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#00C66E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M14.181 22.665l5.746 5.746 15.16-15.265C32.23 9.306 27.656 6.818 22.5 6.818c-8.66 0-15.682 7.021-15.682 15.682 0 8.66 7.021 15.682 15.682 15.682 8.66 0 15.682-7.021 15.682-15.682 0-1.37-.176-2.698-.506-3.964",
    transform: "translate(-1317 -202) translate(1324 205)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessTick);
export default __webpack_public_path__ + "static/media/icon-success-tick.f1d0c017014551ea4fc9478dd08e43d6.svg";
export { ForwardRef as ReactComponent };